//Página para algún error 404
import React from 'react'

const NotFound=()=>(
    <img src="ReactjsListAndInfo/images/404.png" className="img-add" alt="rym404" width="100%" />
)

export default NotFound